// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3092":"19815053","7931":"19815053"}[chunkId] + ".chunk.css";
};